import { Carousel } from "antd";

import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import { useEffect, useState } from "react";

const settings = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 2000,
  autoplay: true,
  autoplaySpeed: 7000,
};

function Clients() {
  const [clientImages, setClientImages] = useState([]);

  useEffect(() => {
    try {
      const imageContext = require.context(
        "../../assets/images/client",
        false,
        /\.(png|jpe?g|svg)$/
      );

      const imagePaths = imageContext.keys().map(imageContext);

      setClientImages(imagePaths);
    } catch (error) {
      console.error("Error loading images:", error);

      setClientImages([]);
    }
  }, []);

  const chunkArray = (array, size) => {
    const result = [];

    for (let i = 0; i < array.length; i += size) {
      let chunk = array.slice(i, i + size);
      if (chunk.length < size) {
        chunk = [...chunk, ...array.slice(0, size - chunk.length)];
      }

      result.push(chunk);
    }

    return result;
  };

  const clientChunks = chunkArray(clientImages, 5);

  return (
    <div className="py-10">
      <h2 className="text-2xl font-bold  mb-6">Our Clients</h2>
      <Carousel
        className="text-center items-center"
        {...settings}
        style={{
          background: "#FAFAFA 0% 0% no-repeat padding-box",
          boxShadow: "0px 3px 6px #0000000D",
          borderRadius: "8px",
          height: "200px",
          alignContent: "center",
        }}
      >
        {clientChunks.map((chunk, idx) => (
          <div key={idx}>
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
              className="mx-5 items-center text-center py-[1px]"
            >
              {chunk.map((client, index) => (
                <div key={index} className="text-center items-center">
                  <img
                    src={client}
                    alt={`Client ${index + 1}`}
                    style={{
                      width: "160px",
                      height: "auto",
                      alignItems: "center",
                      // marginTop: "2px",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default Clients;
